import template from './sw-upselling-global-import.html.twig'
import './sw-upselling-global-import.scss'

const { Component } = Shopware
const { Criteria } = Shopware.Data

Component.register('sw-upselling-global-import', {
    template,

    inject: ['repositoryFactory'],

    data() {
        return {
            isLoading: false,
            csvFile: null,
            errors: [],
            successMessage: null,
            selectedUpselling: null
        }
    },

    watch: {
        '$route'() {
            this.errors = []
            this.successMessage = null
        }
    },

    computed: {
        upsellingCriteria() {
            const criteria = new Criteria()
            criteria.addFilter(Criteria.equals('type', 'productList'))
            return criteria
        },
        currentTab() {
            return this.$route.name === 'sw.upselling.global.import.index.export' ? 'export' : 'import'
        }
    },

    methods: {
        onFileChange(files) {
            if (files && files.length > 0) {
                this.csvFile = files[0]
            } else if (files && files.target && files.target.files) {
                this.csvFile = files.target.files[0]
            } else {
                this.csvFile = files
            }
            this.errors = []
            this.successMessage = null
        },

        async onImport() {
            if (!this.csvFile) return

            this.isLoading = true
            this.errors = []
            this.successMessage = null

            const formData = new FormData()
            formData.append('file', this.csvFile)

            try {
                const response = await fetch('/api/_action/upselling/import', {
                    method: 'POST',
                    headers: {
                        'Authorization': `Bearer ${Shopware.Context.api.authToken.access}`
                    },
                    body: formData
                })

                const result = await response.json()

                if (result.imported !== undefined) {
                    if (result.imported > 0 && result.message) {
                        this.successMessage = result.message
                    }
                    if (result.errors && result.errors.length > 0) {
                        this.errors = result.errors
                    }
                } else {
                    this.errors = [result.error || result.message || 'Import failed']
                }
            } catch (error) {
                this.errors = [error.message]
            } finally {
                this.isLoading = false
            }
        },

        async onExport() {
            if (!this.selectedUpselling) return

            try {
                const response = await fetch(`/api/_action/upselling/export?upsellingId=${this.selectedUpselling}`, {
                    method: 'POST',
                    headers: {
                        'Authorization': `Bearer ${Shopware.Context.api.authToken.access}`
                    }
                })

                const blob = await response.blob()
                const url = window.URL.createObjectURL(blob)
                const a = document.createElement('a')
                a.href = url
                a.download = 'upselling-export.csv'
                a.click()
                window.URL.revokeObjectURL(url)
            } catch (error) {
                this.errors = [error.message]
            }
        }
    }
})
